import styled from 'styled-components'
import { Form, Input } from 'antd'
import { SPACING, TYPOGRAPHY, FONT_WEIGHT } from '../../../styles/theme'

/**
 * Styled components for DeleteAccountForm
 */

export const FormContainer = styled.div`
  max-width: 100%;
`

export const StyledFormItem = styled(Form.Item)`
  margin-bottom: ${SPACING.lg};

  .ant-form-item-label > label {
    font-weight: ${FONT_WEIGHT.medium};
    color: var(--color-text-secondary);
    font-size: ${TYPOGRAPHY.caption.fontSize};
  }
`

export const FormActions = styled.div`
  display: flex;
  justify-content: flex-start;
  padding-top: ${SPACING.sm};
`

export const WarningList = styled.ul`
  margin: 0 0 ${SPACING.xl} 0;
  padding-left: ${SPACING.lg};
  color: var(--color-text-secondary);
  font-size: ${TYPOGRAPHY.caption.fontSize};
  line-height: 1.8;

  li {
    margin-bottom: ${SPACING.xs};
  }
`

export const ConfirmationInput = styled(Input)`
  margin-top: ${SPACING.sm};
`

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.md};
`

export const ModalWarning = styled.div`
  font-size: ${TYPOGRAPHY.caption.fontSize};
  color: var(--color-text-warning, #d89614);
  background: var(--color-bg-warning, rgba(216, 150, 20, 0.08));
  border-radius: 6px;
  padding: ${SPACING.sm} ${SPACING.md};
`
